import React from 'react';
import { createRoot } from 'react-dom/client';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {Grommet} from "grommet";
import { AuthProvider } from "./auth/AuthContext";
import Authenticated from "./auth/Authenticated";
import Guest from "./auth/Guest";
import Login from "./auth/Login";
import Main from "./Main";

import theme from "./theme";
import {Navigation} from "./navigation";

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Grommet full theme={theme}>
          <AuthProvider>
          <Router>
              <Authenticated>
                  <Navigation>
                      <Routes>
                          <Route path="/*" element={<Main />} />
                      </Routes>
                  </Navigation>
              </Authenticated>
              <Guest>
                <Login />
              </Guest>
          </Router>
          </AuthProvider>
      </Grommet>
  </React.StrictMode>
);
